export default "/institutions/pluxee.svg";